import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import {
  getStoreDetailsPanel,
  getTitlePanel,
  infoChangeButton,
} from '../sharedTemplates/CheckoutDispositionInfoViewTemplates';
import { isDeliveryDisposition } from 'common/utilities/utils';

const CheckoutDispositionInfoView = props => {
  const { typeInfo, checkoutDetails, scheduleOrderButtonClickHandler, updateAddressDetails, updateCheckoutDetails } =
    props;
  const { isMobile, type, store, deliveryAddress, address2 } = checkoutDetails;

  return (
    <div className={`row row-cols-12 mt-10px`}>
      {getTitlePanel(
        translateWithI18Next(typeInfo(type)),
        null,
        isMobile ? infoChangeButton({ store, scheduleOrderButtonClickHandler }, 'float-right pr-15px-imp') : null,
      )}
      <div className={`deliveryInfoContent px-25px col-sm-8 col-12`}>
        <div className='d-flex flex-column mt-20px'>
          {getStoreDetailsPanel(
            {
              type,
              store,
              deliveryAddress,
              address2,
              scheduleOrderButtonClickHandler,
              updateAddressDetails,
              updateCheckoutDetails,
              checkoutDetails,
              icon: IMAGE_PATH.LocationOnIcon,
              displayStoreAddress: !isDeliveryDisposition(type),
            },
            null,
            isMobile ? null : infoChangeButton({ store, scheduleOrderButtonClickHandler }),
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(CheckoutDispositionInfoView);
